/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GenericCounterResponse } from '../models/generic-counter-response';
import { GenericTableResponse } from '../models/generic-table-response';
import { getCasesWithoutSourceOrTarget } from '../fn/statistics-dashboard/get-cases-without-source-or-target';
import { GetCasesWithoutSourceOrTarget$Params } from '../fn/statistics-dashboard/get-cases-without-source-or-target';
import { getDeliveredCases } from '../fn/statistics-dashboard/get-delivered-cases';
import { GetDeliveredCases$Params } from '../fn/statistics-dashboard/get-delivered-cases';
import { getLongActiveTours } from '../fn/statistics-dashboard/get-long-active-tours';
import { GetLongActiveTours$Params } from '../fn/statistics-dashboard/get-long-active-tours';
import { getTopDestinationAddressesInPeriod } from '../fn/statistics-dashboard/get-top-destination-addresses-in-period';
import { GetTopDestinationAddressesInPeriod$Params } from '../fn/statistics-dashboard/get-top-destination-addresses-in-period';
import { getTopSourceAddressesInPeriod } from '../fn/statistics-dashboard/get-top-source-addresses-in-period';
import { GetTopSourceAddressesInPeriod$Params } from '../fn/statistics-dashboard/get-top-source-addresses-in-period';
import { getUnassignedCases } from '../fn/statistics-dashboard/get-unassigned-cases';
import { GetUnassignedCases$Params } from '../fn/statistics-dashboard/get-unassigned-cases';
import { getUnassignedEarlyPickupCasesCount } from '../fn/statistics-dashboard/get-unassigned-early-pickup-cases-count';
import { GetUnassignedEarlyPickupCasesCount$Params } from '../fn/statistics-dashboard/get-unassigned-early-pickup-cases-count';

@Injectable({ providedIn: 'root' })
export class StatisticsDashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLongActiveTours()` */
  static readonly GetLongActiveToursPath = '/api/v1/statistics-dashboard/active_tours';

  /**
   * Get active tours that are active more then specified in parameter duration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLongActiveTours()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLongActiveTours$Response(params: GetLongActiveTours$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
    return getLongActiveTours(this.http, this.rootUrl, params, context);
  }

  /**
   * Get active tours that are active more then specified in parameter duration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLongActiveTours$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLongActiveTours(params: GetLongActiveTours$Params, context?: HttpContext): Observable<GenericTableResponse> {
    return this.getLongActiveTours$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericTableResponse>): GenericTableResponse => r.body)
    );
  }

  /** Path part for operation `getCasesWithoutSourceOrTarget()` */
  static readonly GetCasesWithoutSourceOrTargetPath = '/api/v1/statistics-dashboard/cases_without_sourcse_or_target_addresses';

  /**
   * Get cases without source or target addresses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCasesWithoutSourceOrTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCasesWithoutSourceOrTarget$Response(params?: GetCasesWithoutSourceOrTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
    return getCasesWithoutSourceOrTarget(this.http, this.rootUrl, params, context);
  }

  /**
   * Get cases without source or target addresses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCasesWithoutSourceOrTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCasesWithoutSourceOrTarget(params?: GetCasesWithoutSourceOrTarget$Params, context?: HttpContext): Observable<GenericTableResponse> {
    return this.getCasesWithoutSourceOrTarget$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericTableResponse>): GenericTableResponse => r.body)
    );
  }

  /** Path part for operation `getDeliveredCases()` */
  static readonly GetDeliveredCasesPath = '/api/v1/statistics-dashboard/delivered_cases';

  /**
   * Get basic information about delivered cases.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeliveredCases()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveredCases$Response(params?: GetDeliveredCases$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
    return getDeliveredCases(this.http, this.rootUrl, params, context);
  }

  /**
   * Get basic information about delivered cases.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeliveredCases$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveredCases(params?: GetDeliveredCases$Params, context?: HttpContext): Observable<GenericTableResponse> {
    return this.getDeliveredCases$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericTableResponse>): GenericTableResponse => r.body)
    );
  }

  /** Path part for operation `getTopDestinationAddressesInPeriod()` */
  static readonly GetTopDestinationAddressesInPeriodPath = '/api/v1/statistics-dashboard/top_destination_addresses';

  /**
   * Get top destination addresses in last n days.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTopDestinationAddressesInPeriod()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopDestinationAddressesInPeriod$Response(params: GetTopDestinationAddressesInPeriod$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
    return getTopDestinationAddressesInPeriod(this.http, this.rootUrl, params, context);
  }

  /**
   * Get top destination addresses in last n days.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTopDestinationAddressesInPeriod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopDestinationAddressesInPeriod(params: GetTopDestinationAddressesInPeriod$Params, context?: HttpContext): Observable<GenericTableResponse> {
    return this.getTopDestinationAddressesInPeriod$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericTableResponse>): GenericTableResponse => r.body)
    );
  }

  /** Path part for operation `getTopSourceAddressesInPeriod()` */
  static readonly GetTopSourceAddressesInPeriodPath = '/api/v1/statistics-dashboard/top_source_addresses';

  /**
   * Get top source addresses in last n days.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTopSourceAddressesInPeriod()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopSourceAddressesInPeriod$Response(params: GetTopSourceAddressesInPeriod$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
    return getTopSourceAddressesInPeriod(this.http, this.rootUrl, params, context);
  }

  /**
   * Get top source addresses in last n days.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTopSourceAddressesInPeriod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopSourceAddressesInPeriod(params: GetTopSourceAddressesInPeriod$Params, context?: HttpContext): Observable<GenericTableResponse> {
    return this.getTopSourceAddressesInPeriod$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericTableResponse>): GenericTableResponse => r.body)
    );
  }

  /** Path part for operation `getUnassignedCases()` */
  static readonly GetUnassignedCasesPath = '/api/v1/statistics-dashboard/unassigned_cases';

  /**
   * Get basic information about unassigned cases.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnassignedCases()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnassignedCases$Response(params: GetUnassignedCases$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
    return getUnassignedCases(this.http, this.rootUrl, params, context);
  }

  /**
   * Get basic information about unassigned cases.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnassignedCases$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnassignedCases(params: GetUnassignedCases$Params, context?: HttpContext): Observable<GenericTableResponse> {
    return this.getUnassignedCases$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericTableResponse>): GenericTableResponse => r.body)
    );
  }

  /** Path part for operation `getUnassignedEarlyPickupCasesCount()` */
  static readonly GetUnassignedEarlyPickupCasesCountPath = '/api/v1/statistics-dashboard/unassigned_cases_early_pickup';

  /**
   * Get amount of the unassigned cases with transport type early pickup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnassignedEarlyPickupCasesCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnassignedEarlyPickupCasesCount$Response(params?: GetUnassignedEarlyPickupCasesCount$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericCounterResponse>> {
    return getUnassignedEarlyPickupCasesCount(this.http, this.rootUrl, params, context);
  }

  /**
   * Get amount of the unassigned cases with transport type early pickup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnassignedEarlyPickupCasesCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnassignedEarlyPickupCasesCount(params?: GetUnassignedEarlyPickupCasesCount$Params, context?: HttpContext): Observable<GenericCounterResponse> {
    return this.getUnassignedEarlyPickupCasesCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericCounterResponse>): GenericCounterResponse => r.body)
    );
  }

}
